export default "__VITE_ASSET__COhXxyi0__"